import { computed, ref } from 'vue'
import type { Ref } from 'vue'

import { cloneDeep } from 'lodash'
import { useI18n } from 'vue-i18n'
import type { VForm } from 'vuetify/components'

import { applyRules, isRequired, isValidEmail, validate } from '@tsyl/radon'

import type { User, UserManagementEmits } from '@/types/User.ts'

export default (user: User, emits: UserManagementEmits, form: Ref<InstanceType<typeof VForm> | undefined>) => {
  const { t } = useI18n()
  const rules = computed(() => {
    return {
      nickname: validate(t('domain.fields.nickname'), isRequired()),
      email: validate(t('domain.fields.email'), isRequired(), isValidEmail()),
      given_name: validate(t('domain.fields.firstName'), isRequired()),
      family_name: validate(t('domain.fields.lastName'), isRequired()),
      roles: validate(t('domain.fields.roles'), isRequired())
    }
  })

  const formUser = ref(cloneDeep(user))
  formUser.value.roles = []
  formUser.value.given_name = user.user_metadata?.given_name || user.given_name
  formUser.value.family_name = user.user_metadata?.family_name || user.family_name

  const save = () => {
    const values = {
      ...formUser.value
    }
    const valid = applyRules(rules.value, {
      ...values
    })
    form.value?.validate()
    if (valid === true) emits('save', values)
  }

  return {
    rules,
    save,
    formUser
  }
}
